const global = {
  actions: {
    /**
     * 全局请求头（可设置Token），传参包含请求URL（附带contextPath），可做更细处理
     * 支持返回Promise
     */
    globalRequestHeaders: function () {
      return {}
    },
    /**
     * 全局请求参数（可设置access_token），传参包含请求URL（附带contextPath），可做更细处理
     * 支持返回Promise
     */
    globalActionParams: function () {
      return {}
    }
  }
}

export default global
